import React, { useContext } from 'react'

import { bool } from 'prop-types'
import getNewIcon from 'utils/getNewIcon'

import Typography from 'components/atoms/Typography'
import { NotificationCtx } from 'components/notifications/NotificationProvider'
import Badge from 'components/atoms/Badge/Badge'

const NotificationMenu = ({ isActive }) => {
  const color = isActive ? '#00C2C9' : '#6B8FBC'
  const iconName = isActive ? 'bellFull' : 'bell'
  const { state: notifState } = useContext(NotificationCtx)

  return (
    <>
      <div className="notification-menu">
        <div className="notification-menu__icon">
          {getNewIcon(iconName, color)}
          {notifState.totalUnreadNotif > 0 && <Badge variant="red">{notifState.totalUnreadNotif}</Badge>}
        </div>
        <Typography variant="note" fontWeight="bold" component="span" className="notification-menu__label">
          Notifikasi
        </Typography>
      </div>
      <style jsx global>
        {`
          .notification-menu {
            position: relative;
            height: 78px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            cursor: pointer;
            span {
              color: ${color};
            }
            &:focus, &:hover  {
              text-decoration: none;
            }
            &__icon {
              position: relative;
              svg {
                width: 24px;
                height: 24px;
              }
              .campus-badge {
                position: absolute !important;
                top: -2px;
                right: -5px;
                border-radius: 20px !important;
                padding: 0.5px 6px !important;
              }
            }
            &__label {
              display: none;
            }
          }
          @media screen and (min-width: 768px) {
            margin-left: 0;
            .notification-menu__label {
              display: block;
            }
          }
        `}
      </style>
    </>
  )
}

NotificationMenu.propTypes = {
  isActive: bool,
}

NotificationMenu.defaultProps = {
  isActive: false,
}

export default NotificationMenu
